export default __webpack_public_path__ + "static/media/user-avatar-5.6cbaeef4.png";